'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _reactIntl = require('react-intl');

var _auth = require('../../redux/modules/auth');

var _popup = require('../../redux/modules/popup');

var _log = require('../../redux/modules/log');

var _PopupType = require('../../helpers/PopupType');

var _Product = require('../../helpers/Product');

var _DefaultString = require('../../helpers/DefaultString');

var _ClientError = require('../../helpers/ClientError');

var _Router = require('../../helpers/Router');

var _Error = require('../../helpers/Error');

var _Logs = require('../../helpers/Logs');

var _Logs2 = _interopRequireDefault(_Logs);

var _google = require('../../../res/images/icon/google.svg');

var _google2 = _interopRequireDefault(_google);

var _GoogleLoginButton = require('./GoogleLoginButton.scss');

var _GoogleLoginButton2 = _interopRequireDefault(_GoogleLoginButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoogleLoginButton = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    appInfo: state.appInfo,
    auth: state.auth,
    initLang: state.auth.initLang,
    lang: state.auth.lang,
    log: state.log
  };
}, {
  changePopupType: _popup.changePopupType,
  googleLogin: _auth.googleLogin,
  googleUpgrade: _auth.googleUpgrade,
  logConnectionMethod: _log.logConnectionMethod,
  pushState: _reactRouterRedux.push
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(GoogleLoginButton, _React$Component);

  function GoogleLoginButton(props) {
    (0, _classCallCheck3.default)(this, GoogleLoginButton);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GoogleLoginButton.__proto__ || (0, _getPrototypeOf2.default)(GoogleLoginButton)).call(this, props));

    _this.state = {
      googleAccount: null
    };

    _this.loadGoogleGsiScript = function () {
      return new _promise2.default(function (resolve, reject) {
        var existingScriptTag = document.getElementById('google-gsi-client');
        if (existingScriptTag) {
          if (existingScriptTag.dataset.loaded) {
            resolve();
            return;
          }
          existingScriptTag.addEventListener("load", function () {
            resolve();
          });
          return;
        }

        var scriptTag = document.createElement('script');
        scriptTag.src = 'https://accounts.google.com/gsi/client';
        scriptTag.id = 'google-gsi-client';
        scriptTag.async = true;
        scriptTag.defer = true;
        scriptTag.addEventListener("load", function () {
          scriptTag.dataset.loaded = "true";
          resolve();
        });
        scriptTag.addEventListener("error", function () {
          reject();
        });

        document.body.appendChild(scriptTag);
      });
    };

    _this.getText = function () {
      return _DefaultString.translations.Google;
    };

    _this.getIcon = function () {
      return _google2.default;
    };

    _this.onGoogleLoginClick = function () {
      if (_this.state.googleAccount) {
        _this.state.googleAccount.requestCode();
      }
    };

    _this.hasCustomClick = function () {
      return [_Product.PLATFORM_NAMES.Ipad, _Product.PLATFORM_NAMES.Iphone, _Product.PLATFORM_NAMES.Android, _Product.PLATFORM_NAMES.AndroidTablet].includes(_this.props.auth.platform);
    };

    _this.isEnabled = function () {
      var product = (0, _Product.getThemedProduct)(_this.props.auth.productName, _this.props.auth.clientId);
      var googleConfig = _this.props.appInfo.google && _this.props.appInfo.google[product];
      return !!googleConfig && googleConfig.enableLogin;
    };

    _this.setupGoogleAccounts = _this.setupGoogleAccounts.bind(_this);
    _this.handleCredentialResponse = _this.handleCredentialResponse.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(GoogleLoginButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.isEnabled()) {
        this.setupGoogleAccounts();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener("load", this.loadListener);
    }
  }, {
    key: 'setupGoogleAccounts',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.loadGoogleGsiScript();

              case 2:
                this.state.googleAccount = window.google.accounts.oauth2.initCodeClient({
                  client_id: this.props.appInfo.google[this.props.auth.productName].clientId,
                  scope: 'openid profile email',
                  callback: this.handleCredentialResponse
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setupGoogleAccounts() {
        return _ref.apply(this, arguments);
      }

      return setupGoogleAccounts;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.auth.googleLoggingIn && !nextProps.auth.googleLoggingIn) {
        if (nextProps.auth.error) {
          var response = nextProps.auth.error.response;
          if (response && (response.body.code === _Error.ErrorConst.InvalidCaptcha || response.body.code === _Error.ErrorConst.InvalidValue)) {
            this.props.changePopupType(_PopupType.PopupId.GoogleLoginError);
          } else {
            (0, _ClientError.logClientErrorWithLoggingService)(nextProps.auth.error, new Error().stack, 'universal-loginError', this.props.auth);
            this.props.pushState((0, _Router.getErrorRetryPath)());
          }
        }
      }
    }
  }, {
    key: 'handleCredentialResponse',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(response) {
        var setPasswordUri;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.hasCustomClick()) {
                  _context2.next = 2;
                  break;
                }

                throw new Error('TODO Custom click for mobile app');

              case 2:

                this.props.logConnectionMethod(_Logs.LogName.ConnectWithGoogle);
                (0, _Logs2.default)(this.props.log.src, _Logs.LogName.ConnectWithGoogle, this.props.log, this.props.auth, this.props.appInfo);

                try {
                  setPasswordUri = window.location.origin + (0, _Router.getPathForEmailLink)(_Router.RouterConst.CreatePasswordAndLinkToProfile, this.props.lang);

                  if (this.props.auth.sessionId) {
                    this.props.googleUpgrade(response.code, this.props.lang, setPasswordUri, this.props.auth.sessionId);
                  } else {
                    this.props.googleLogin(response.code, this.props.lang, setPasswordUri);
                  }
                } catch (error) {
                  // Only handle the error if it is not because the user closed the popup
                  if (error.error !== 'popup_closed_by_user') {
                    (0, _ClientError.logClientErrorWithLoggingService)(error, new Error().stack, 'universal-loginError-Google', this.props.auth);
                    this.props.changePopupType(_PopupType.PopupId.GoogleLoginError);
                  }
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleCredentialResponse(_x) {
        return _ref2.apply(this, arguments);
      }

      return handleCredentialResponse;
    }()

    // If the button onclick should use a custom function or the default Google functionality

  }, {
    key: 'render',
    value: function render() {
      if (!this.isEnabled()) {
        return null;
      }
      var text = this.getText();
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'button',
          { type: 'button', className: _GoogleLoginButton2.default.googleButton, onClick: this.onGoogleLoginClick },
          _react2.default.createElement(
            'div',
            { className: 'social-icon-container' },
            _react2.default.createElement('img', { src: this.getIcon(), alt: this.props.intl.formatMessage(text) })
          ),
          _react2.default.createElement(_reactIntl.FormattedMessage, text)
        )
      );
    }
  }]);
  return GoogleLoginButton;
}(_react2.default.Component), _class2.propTypes = {
  appInfo: _react.PropTypes.object,
  auth: _react.PropTypes.object,
  changePopupType: _react.PropTypes.func,
  googleLogin: _react.PropTypes.func.isRequired,
  googleUpgrade: _react.PropTypes.func.isRequired,
  initLang: _react.PropTypes.string,
  intl: _reactIntl.intlShape.isRequired,
  lang: _react.PropTypes.string,
  log: _react.PropTypes.object,
  logConnectionMethod: _react.PropTypes.func.isRequired,
  pushState: _react.PropTypes.func.isRequired
}, _temp)) || _class);
exports.default = (0, _reactIntl.injectIntl)(GoogleLoginButton);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/GoogleLoginButton/GoogleLoginButton.js
// module id = 1955
// module chunks = 0